export default __webpack_public_path__ + "static/media/gsm.90c56683.svg";